function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Hive"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtract",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.8146 2.19608C12.303 1.93464 11.697 1.93464 11.1854 2.19608L2.97557 6.39146C2.37681 6.69744 2 7.31315 2 7.98557V16.0148C2 16.6872 2.37681 17.3029 2.97557 17.6089L11.1854 21.8043C11.697 22.0657 12.303 22.0657 12.8146 21.8043L21.0244 17.6089C21.6232 17.3029 22 16.6872 22 16.0148V7.98557C22 7.31315 21.6232 6.69744 21.0244 6.39146L12.8146 2.19608ZM12.6377 4.32586C12.2372 4.12121 11.7628 4.1212 11.3623 4.32586L4.93599 7.60985C4.4673 7.84936 4.17235 8.33131 4.17235 8.85766V15.1427C4.17235 15.669 4.4673 16.151 4.93599 16.3905L11.3623 19.6745C11.7628 19.8791 12.2372 19.8791 12.6377 19.6745L19.064 16.3905C19.5327 16.151 19.8276 15.669 19.8276 15.1427V8.85766C19.8276 8.33131 19.5327 7.84936 19.064 7.60985L12.6377 4.32586Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtract_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4888 6.11765C12.1818 5.96078 11.8182 5.96078 11.5112 6.11765L6.58528 8.6349C6.22601 8.81849 5.99992 9.18792 5.99992 9.59138V14.409C5.99992 14.8124 6.22601 15.1819 6.58528 15.3655L11.5112 17.8827C11.8182 18.0396 12.1818 18.0396 12.4888 17.8827L17.4147 15.3655C17.774 15.1819 18.0001 14.8124 18.0001 14.409V9.59138C18.0001 9.18792 17.774 8.81849 17.4147 8.6349L12.4888 6.11765ZM12.326 8.07864C12.1213 7.97407 11.8789 7.97407 11.6743 8.07864L8.39045 9.75674C8.15095 9.87913 8.00023 10.1254 8.00023 10.3944V13.606C8.00023 13.8749 8.15095 14.1212 8.39045 14.2436L11.6743 15.9217C11.8789 16.0263 12.1213 16.0263 12.326 15.9217L15.6098 14.2436C15.8493 14.1212 16 13.8749 16 13.606V10.3944C16 10.1254 15.8493 9.87913 15.6098 9.75674L12.326 8.07864Z",
  fill: "none"
}));

var SvgHive = function SvgHive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hive.c79a3c6a.svg";
export { ForwardRef as ReactComponent };